<app-page-heading [heading]="getHeadingDisplayString()" [hasBackButton]="true" [backPageName]="backPageName"
                  [tabName]="tabName">
</app-page-heading>


<div class="stepper-container">
  <mat-horizontal-stepper #stepper [linear]="true">
    <mat-step #generalStep [completed]="generalFormGroup.valid">
      <ng-template matStepLabel>General</ng-template>
      <form [formGroup]="generalFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Price List Name</mat-label>
              <input matInput required type="text" [formControl]="nameFormControl">
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Price List Name')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Price List Code</mat-label>
              <input matInput
                     required
                     type="text"
                     maxlength="20"
                     [formControl]="codeFormControl">
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Price List Code')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Price List Type</mat-label>
              <mat-select required [formControl]="typeFormControl">
                <mat-option *ngFor="let type of types" [value]="type.name">
                  {{type.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Price List Type')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Administrator</mat-label>
              <mat-select required [formControl]="administratorFormControl">
                <mat-option *ngFor="let administrator of administrators" [value]="administrator.name">
                  {{administrator.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Administrator')" class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
          </mat-grid-tile>
        </mat-grid-list>

        <div class="button-container">
          <button mat-raised-button color="warn" (click)="resetGeneralFormGroup()">Clear</button>
          <button mat-raised-button matStepperNext color="primary">Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step #discountStep [completed]="discountFormGroup.valid">
      <ng-template matStepLabel>Settlement Discounts</ng-template>
      <form [formGroup]="discountFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Days</mat-label>
              <input [formControl]="daysFormControl" type="number" matInput>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Days')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Percentage</mat-label>
              <input [formControl]="percentageFormControl" type="number" pattern="^[0-9]*\.?[0-9]+$" matInput>
              <span matSuffix>%</span>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Percentage')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Start Date</mat-label>
              <input [formControl]="discountStartDateFormControl" [max]="discountEndDateFormControl.value"
                     [matDatepicker]="settlementStartDatePicker" matInput>
              <mat-datepicker-toggle [for]="settlementStartDatePicker" matIconSuffix>
              </mat-datepicker-toggle>
              <mat-datepicker #settlementStartDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Start Date Settlement Discount')" class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>End Date</mat-label>
              <input [formControl]="discountEndDateFormControl" [min]="discountStartDateFormControl.value"
                     [matDatepicker]="settlementEndDatePicker" matInput>
              <mat-datepicker-toggle [for]="settlementEndDatePicker" matIconSuffix>
              </mat-datepicker-toggle>
              <mat-datepicker #settlementEndDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('End Date Settlement Discount')" class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <div class="align-center">
          <mat-error style="margin-bottom: 12px"
                     *ngIf="discountFormGroup.touched && !discountRequiredFieldsSelected">{{discountMessage}}
          </mat-error>
          <button mat-raised-button color="primary" (click)="addDiscount()">Add Discount</button>
        </div>

        <mat-divider style="margin-bottom: 16px;margin-top: 16px;" *ngIf="selectedDiscounts?.length > 0"></mat-divider>

        <div *ngIf="selectedDiscounts?.length > 0" class="left-content">
          <label class="column-label claim-column-label">Selected Settlement Discounts</label>
        </div>
        <div class="left-content reporting-list" *ngFor="let discount of selectedDiscounts">
          <mat-icon class="table-icon" matTooltip="REMOVE Discount" (click)="removeDiscount(discount)">delete
          </mat-icon>
          <mat-icon class="table-icon" matTooltip="EDIT Discount" (click)="editDiscount(discount)">edit</mat-icon>
          <p>
            {{getDiscountDisplayString(discount)}}
          </p>
        </div>

        <div class="button-container">
          <button mat-raised-button matStepperPrevious color="primary">Back</button>
          <button mat-raised-button color="warn" (click)="resetDiscountFormGroup()">Clear</button>
          <button mat-raised-button matStepperNext color="primary">Next</button>
        </div>
      </form>
    </mat-step>
    <mat-step #priceListStep [completed]="priceListFormGroup.valid">
      <ng-template matStepLabel>Prices</ng-template>

      <div class="flex justify-between">
        <div class="flex items-center">
          <label class="mat-primary-color mr2">Display prices for: </label>
          <mat-radio-group [(ngModel)]="chosenDataSource"
                           [ngModelOptions]="{standalone: true}">
            <mat-radio-button (change)="toggleDataSource($event.value)" *ngFor="let source of dataSources"
                              [value]="source"
                              class="radio-button mr2">
              {{source}}
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="flex justify-between">
          <button mat-raised-button color="accent" class="m-r-10" (click)="downloadFile()" disabled>
            <mat-icon>arrow_downward</mat-icon>Download Template
          </button>
          <button mat-raised-button color="accent" class="m-r-10" (click)="fileInput.click()" disabled>
            <mat-icon>arrow_upward</mat-icon>Import Prices
            <input #fileInput type="file" accept=".csv" (change)="fileUploadListener($event)" style="display:none;" />
          </button>
          <button mat-raised-button color="accent" (click)="openPriceDialog(null)">
            <mat-icon>add</mat-icon>Add Price
          </button>
        </div>
      </div>

      <div *ngIf="chosenDataSource == PROVIDER">
        <mat-form-field>
          <mat-label>{{chosenDataSource}}</mat-label>

          <input matInput type="text" [placeholder]="getInfoTooltip('Entity Search')"
                 [formControl]="entityFormControl" (input)="onInputChangedSearchProviders($event)"
                 [matAutocomplete]="entityAuto">
          <mat-autocomplete #entityAuto="matAutocomplete" [panelWidth]="'40vw'">
            <mat-option *ngFor="let entity of getFilteredProviderValues()" [value]="entity.name"
                        (onSelectionChange)="setDataSource(chosenDataSource, entity.name)">
              {{entity.name}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>

      <div *ngIf="chosenDataSource == PROVIDER_NETWORK">
        <mat-form-field>
          <mat-label>{{chosenDataSource}}</mat-label>
          <mat-select [formControl]="entityFormControl"
                      (selectionChange)="setDataSource(chosenDataSource, entityFormControl.value)">
            <mat-option *ngFor="let entity of providerNetworks"
                        [value]="entity.name">
              {{entity.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div *ngIf="!priceListDataSource" class="center-container">
        <mat-spinner></mat-spinner>
      </div>

      <div *ngIf="priceListDataSource" class="mat-elevation-z8">
        <table mat-table multiTemplateDataRows [dataSource]="priceListDataSource" matSort>

          <ng-container matColumnDef="icons">
            <th *matHeaderCellDef mat-header-cell></th>
            <td *matCellDef="let row" mat-cell>
              <mat-icon class="table-icon" (click)="openPriceDialog(row)"
                        matTooltip="EDIT Price">edit
              </mat-icon>
              <mat-icon class="table-icon" (click)="removePrice(row)"
                        matTooltip="DELETE Price">
                delete
              </mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="codingSchema">
            <th *matHeaderCellDef mat-header-cell>Coding Schema</th>
            <td *matCellDef="let row" mat-cell>{{row.codingSchema.code}}: {{row.codingSchema.shortDescription | slice:0:50}}</td>
          </ng-container>

          <ng-container matColumnDef="proprietaryCode">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Proprietary Code</th>
            <td *matCellDef="let row" mat-cell>{{row.proprietaryCode}}</td>
          </ng-container>

          <ng-container matColumnDef="proprietaryDescription">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Proprietary Description</th>
            <td *matCellDef="let row" mat-cell>{{row.proprietaryDescription}}</td>
          </ng-container>

          <ng-container matColumnDef="grossAmount">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Gross Amount</th>
            <td *matCellDef="let row" mat-cell>{{formatToCurrency(row.grossAmount)}}</td>
          </ng-container>

          <ng-container matColumnDef="discountAmount">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Discount Amount</th>
            <td *matCellDef="let row" mat-cell>{{formatToCurrency(row.discountAmount)}}</td>
          </ng-container>

          <ng-container matColumnDef="currency">
            <th *matHeaderCellDef mat-header-cell>Currency</th>
            <td *matCellDef="let row" mat-cell>{{row.currency.name | uppercase}}</td>
          </ng-container>

          <ng-container matColumnDef="startDate">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
            <td *matCellDef="let row" mat-cell>{{row.startDate | date: dateFormat}}</td>
          </ng-container>

          <ng-container matColumnDef="endDate">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
            <td *matCellDef="let row" mat-cell>{{row.endDate | date: dateFormat}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="priceListDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: priceListDisplayedColumns;"></tr>
        </table>

        <mat-paginator [pageSizeOptions]="this.pageSizeOptions">
        </mat-paginator>

      </div>
      <div class="button-container">
        <button mat-raised-button matStepperPrevious color="primary">Back</button>
        <button mat-raised-button color="warn" (click)="resetPriceFormGroup()">Clear</button>
        <button mat-raised-button matStepperNext color="primary">Next</button>
      </div>
    </mat-step>
    <mat-step #productStep [completed]="productFormGroup.valid">
      <ng-template matStepLabel>Products</ng-template>
      <form [formGroup]="productFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Product</mat-label>
              <input matInput type="text" [placeholder]="getInfoTooltip('Coding Schema')"
                     [formControl]="productFormControl" (input)="onInputChangedSearchProducts($event)"
                     [matAutocomplete]="productAuto">
              <mat-autocomplete #productAuto="matAutocomplete" [panelWidth]="'40vw'">
                <mat-option *ngFor="let product of filteredProducts"
                            [value]="getProductSelectListDisplayString(product)" class="custom-mat-option">
                  {{getProductSelectListDisplayString(product)}}
                </mat-option>
              </mat-autocomplete>
              <button mat-button mat-icon-button matSuffix  (click)="addProduct()">
                <mat-icon style="color: grey;">add</mat-icon>
              </button>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Product')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-divider *ngIf="selectedProducts?.length > 0"></mat-divider>

        <mat-error style="margin-bottom: 12px"
        *ngIf="productAlreadySelected">{{productAlreadySelectedMessage}}
        </mat-error>
        <mat-error class="left-content claim-column-label"
                   *ngIf="productFormGroup.errors && productFormGroup.errors.minimumProduct">Least 1 produced added
        </mat-error>
        <div *ngIf="selectedProducts?.length > 0" class="left-content" style="margin-top: 16px">
          <label class="column-label claim-column-label">Selected Products</label>
        </div>
        <div class="left-content reporting-list" *ngFor="let product of selectedProducts">
          <mat-icon class="table-icon" matTooltip="REMOVE Product" (click)="removeProduct(product)">delete
          </mat-icon>
          <p>
            {{getProductDisplayString(product.product)}}
          </p>
        </div>

        <div class="button-container">
          <button #productBackButton mat-raised-button matStepperPrevious color="primary">Back</button>
          <button #productClearButton mat-raised-button color="warn" (click)="resetProductFormGroup()">Clear</button>
          <button #finishButton mat-raised-button matStepperNext color="primary"
                  [disabled]="disableFinishButton()"
                  (click)="checkProductValue()">
              Finish
            <mat-icon *ngIf="disableFinishButton()" class="info-icon"
                      [matTooltip]="getFinishButtonTooltip()">
              help_outline
            </mat-icon>
          </button>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>
</div>
